import React from "react";
import Drawer from "./Drawer";
import {
  Grid,
  Typography,
  AppBar,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { themeMain } from "../components/wrapper/CThemeProvider";

const ResolverHeader = ({
  cLogo,
  cLogoSmall,
  handleLogin,
  handleLogout,
  cUserName,
  cUserInitials,
  pageTitle,
  appRouteMap,
  drawerList,
  pathName,
  navigate,
  linkComponent,
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
 

  return (
    <AppBar
      sx={{
        backgroundColor: themeMain.palette.mainbg.main,
        padding: "0.5em 1em",
      }}
    >
      <Grid container alignItems="center">
        <Grid item xs={1.5} sm={1} md={1} lg={0.5} xl={0.5}>
          <Drawer
            appRouteMap={appRouteMap}
            drawerList={drawerList}
            pathName={pathName}
            linkComponent={linkComponent}
          />
        </Grid>
        <Grid item xs={1} sm={2.5} md={2} lg={2} xl={1.5}>
          <Box
            component="img"
            src={isXs ? cLogoSmall : cLogo}
            // alt="Click to see All Services"
            // onClick={() => handleLogoClick(cUserName, navigate)}
            sx={{
              maxWidth: "80%",
              maxHeight: "100%",
              cursor: "pointer",
              objectFit: "contain",
              height: "1.6em",
              width: "auto",
            }}
          />
        </Grid>
        <Grid
          item
          xs={7}
          sm={5}
          md={6}
          lg={6.5}
          xl={7}
          sx={{ textAlign: "center" }}
        >
          <Typography
            color="secondary"
            fontSize={isXs ? "1.2rem" : "1.6rem"}
            whiteSpace="nowrap"
          >
            {pageTitle}
          </Typography>
        </Grid>
        <Grid
          item
          xs={2.5}
          sm={3.5}
          md={3}
          lg={3}
          xl={3}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >

        </Grid>
      </Grid>
    </AppBar>
  );
};

export default ResolverHeader;
